import React from 'react';
export function ShopByCategory() {
  const categories = [{
    title: 'Socks',
    image: 'https://cdn.magicpatterns.com/uploads/hsgFCfczEqrsDBrdoiWn6r/pure-pulse-socks.webp'
  }, {
    title: 'Sets',
    image: 'https://cdn.magicpatterns.com/uploads/oQgnNwUYGXC7zGeT4uohuR/pure-pulse-sets.webp'
  }, {
    title: 'Bottoms',
    image: 'https://cdn.magicpatterns.com/uploads/o9nZ52Gs8uRMPkT8KRs1z9/pure-pulse-bottoms.webp'
  }, {
    title: 'Accessories',
    image: 'https://cdn.magicpatterns.com/uploads/d1KFhK78ZcMqkUByyZbGWF/pure-pulse-accessories-balace.webp'
  }];
  return <section className="py-16 md:py-24 px-6" data-id="element-140">
      <div className="max-w-7xl mx-auto" data-id="element-141">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-142">
          {categories.map(category => <a key={category.title} href="#" className="group relative aspect-[3/4] overflow-hidden" data-id="element-143">
              <img src={category.image} alt={category.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-144" />
              <div className="absolute inset-0 bg-gradient-to-t from-espresso/70 via-espresso/30 to-espresso/10 group-hover:from-espresso/80 group-hover:via-espresso/40 transition-colors duration-300" data-id="element-145" />
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center" data-id="element-146">
                <h3 className="font-serif font-light text-2xl md:text-3xl text-cream mb-2" data-id="element-147">
                  {category.title}
                </h3>
                <span className="text-cream text-sm uppercase tracking-widest border-b border-rust pb-1" data-id="element-148">
                  SHOP NOW
                </span>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}